
import { defineComponent } from 'vue'
import { iLov } from '../../../LovsManagement'
import { removeUnusedVisibleColumnsFromModel } from './LovsManagementTestDialogHelpers'
import Dialog from 'primevue/dialog'
import Dropdown from 'primevue/dropdown'
import lovsManagementTestDialogDescriptor from './LovsManagementTestDialogDescriptor.json'
import LovsManagementSimpleDatatable from './LovsManagementSimpleDatatable/LovsManagementSimpleDatatable.vue'
import LovsManagementTree from './LovsManagementTree/LovsManagementTree.vue'
import deepcopy from 'deepcopy'

export default defineComponent({
    name: 'lovs-management-test-dialog',
    components: { Dialog, Dropdown, LovsManagementSimpleDatatable, LovsManagementTree },
    emits: ['close', 'pageChanged', 'save'],
    props: {
        visible: { type: Boolean },
        testModel: {
            type: Object
        },
        testLovModel: {
            type: Array
        },
        selectedLov: {
            type: Object
        },
        testLovTreeModel: {
            type: Array
        },
        tableModelForTest: {
            type: Array
        }
    },
    data() {
        return {
            lovsManagementTestDialogDescriptor,
            lov: {} as iLov,
            treeListTypeModel: {} as any,
            model: {} as any,
            treeModel: {} as any
        }
    },
    computed: {
        buttonDisabled(): boolean {
            if (this.treeListTypeModel.LOVTYPE !== 'simple') {
                return this.treeModel.length === 0
            }
            return false
        }
    },
    watch: {
        visible() {
            this.loadLov()
            this.loadTypeModel()
            this.loadModel()
            this.loadTreeModel()
        },
        selectedLov() {
            this.loadLov()
        },
        testModel() {
            this.loadTypeModel()
        },
        testLovModel() {
            this.loadModel()
            this.loadTypeModel()
        },
        testLovTreeModel() {
            this.loadTreeModel()
        }
    },
    created() {
        this.loadLov()
        this.loadTypeModel()
        this.loadModel()
        this.loadTreeModel()
    },
    methods: {
        loadLov() {
            this.lov = this.selectedLov as iLov
        },
        loadTypeModel() {
            this.treeListTypeModel = deepcopy(this.testModel)
            removeUnusedVisibleColumnsFromModel(this.treeListTypeModel, this.tableModelForTest ?? [])
        },
        loadModel() {
            this.model = deepcopy(this.testLovModel)
        },
        loadTreeModel() {
            this.treeModel = deepcopy(this.testLovTreeModel)
        },
        resetValues() {
            this.treeModel = []
            if (this.treeListTypeModel.LOVTYPE === 'simple') {
                delete this.treeListTypeModel['VALUE-COLUMNS']
                delete this.treeListTypeModel['DESCRIPTION-COLUMNS']
                this.treeListTypeModel['VALUE-COLUMN'] = ''
                this.treeListTypeModel['DESCRIPTION-COLUMN'] = ''
            } else {
                delete this.treeListTypeModel['VALUE-COLUMN']
                delete this.treeListTypeModel['DESCRIPTION-COLUMN']
                this.treeListTypeModel['VALUE-COLUMNS'] = ''
                this.treeListTypeModel['DESCRIPTION-COLUMNS'] = ''
            }
            this.treeListTypeModel['VISIBLE-COLUMNS'] = ''
        },
        onSave() {
            this.$emit('save', { treeListTypeModel: this.treeListTypeModel, model: this.model, treeModel: this.treeModel })
        },
        onModelChange(event: any) {
            this.treeListTypeModel = event
        },
        onTreeModelChange(event: any) {
            this.treeModel = event
        }
    }
})
